<template>
  <div>
    <multiselect
      v-model="value"
      :placeholder="$t('Search Brand')"
      label="name"
      track-by="id"
      :options="brands"
      :multiple="true"
      @update:modelValue="$emit('update:value', $event)"
    >
    </multiselect>
    <input type="hidden" v-for="(s, index) in value" :key="index" name="brands[]" :value="s.id">
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  props: {
    brands: {
      type: Array,
      required: true
    },
    selectedBrands: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      value: this.selectedBrands.map(brand => {
        return {
          id: brand.id,
          name: brand.name
        };
      })
    };
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>